"use client";
import { useMediaQuery } from "@react-hooks-library/core";
import { useEffect, useState } from "react";

// useMediaQuery resolves the real match synchronously on the client's first render (unlike SSR,
// which has no window), so its value can't be trusted before mount without causing a hydration
// mismatch whenever it drives structurally different output (not just a className/style).
export default function useSsrSafeMediaQuery(query: string): boolean {
    const rawMatches = useMediaQuery(query);
    const [hasMounted, setHasMounted] = useState(false);
    // eslint-disable-next-line react-hooks/set-state-in-effect -- deliberate mount flag, see the comment above
    useEffect(() => setHasMounted(true), []);
    return hasMounted && rawMatches;
}
